import swal from "sweetalert";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Baseurl from "../../Baseurl";
import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";
import { resolveOnChange } from "antd/lib/input/Input";
export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export function signupAction(email, password, history) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data. expiresIn * 1000, history);
        dispatch(confirmedSignupAction(response.data));
        history.push("/");
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function logout(history) {
  let details=JSON.parse(localStorage.getItem("userDetails"))
  // axios.put(`${Baseurl.baseurl}/staff/staff-logout/${details.staff._id}`).then((res) => {
  //   console.log("logout successfully done",res)
  
  // });
  localStorage.removeItem("userDetails");
  localStorage.removeItem("OTP");
  localStorage.removeItem("permissions");
  history.push("/login");
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, history,setLoader) {
 
  return (dispatch) => {
    if(window.navigator.onLine)
    {
      login(email, password)
      .then((response) => {
        if (response.data.status) {
          response.data.token=true
          console.log("rsosmsm",response.data)
          dispatch(loadingToggleAction(false));
          history.push('/otp-verification')
          saveTokenInLocalStorage(response.data);
        
         // dispatch(loginConfirmedAction(response.data));
          // let vig = response.data.staff.Role;
          // axios
          //   .get(`${Baseurl.baseurl}/go-roles/get-roles`)
          //   .then((response) => {
          //     response.data.details.map((val) => {
          //       if (val.Title === vig) {
          //         let vikki = val.Permissions[0];
          //         Permission.map((val) => {
          //           if (val.title === vikki){
          //             history.push(`${val.path}`);
          //           }
          //         });
          //       }
          //     });
          //   });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
          const errorMessage = formatError(response.data.message);
          dispatch(loginFailedAction(errorMessage));
        }
        setLoader(false)
      })
      .catch((error) => {
        const errorMessage = formatError(error);
        dispatch(loginFailedAction(errorMessage));
      });
    }  
    else
    { 
      swal("Oops","Please Check the Internet Connection", "error", {timer: 3000,});
    }
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
